import { isNullOrUndefinedOrEmptyString } from "./Utils/Various";

export enum Environment {
    DEV = "dev",
    STAGING = "staging",
    PRODUCTION = "production",
}

export interface IConfig {
    environment: Environment;

    // Backend API URL
    backendAPIURL: string;
    UsersUrl: string;
    // CM URL
    CMUrl: string;
    // How many retries we should do for WS reconnection backoff, -1 for unlimited
    // The delay starts at 5 seconds and is doubled every try until capping reached.
    backendRetries: number;
    // Backend retry delay capping, in milliseconds
    backendRetriesCapping: number;
    // Backend retry starting delay
    backendRetriesStart: number;

    // Loglevel
    logLevel: 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'fatal';

    // verison
    version: string;
}

export let Config: IConfig;
let version = "0.2.1"
if (!isNullOrUndefinedOrEmptyString(process.env.REACT_APP_VERSION)) {
    version = process.env.REACT_APP_VERSION
}
console.log("============version ", process.env.REACT_APP_VERSION)
switch (process.env.REACT_APP_STAGE) {
  case Environment.PRODUCTION:
    // tslint:disable: no-console
    if ("console" in window && typeof console.log === "function") {
      console.log("Using production build");
    }
    // tslint:disable: no-console
    Config = {
      // No leading / !
      backendAPIURL: "https://ws-talk.yacast.fr",
      CMUrl: "https://catalog.yacast.fr",
      UsersUrl: "https://users.yacast.fr",
      backendRetries: 10,
      backendRetriesCapping: 30000,
      backendRetriesStart: 5000,
      environment: Environment.PRODUCTION,
      logLevel: "warn",
      version,
    };
    break;
  case Environment.STAGING:
    // tslint:disable: no-console
    if ("console" in window && typeof console.log === "function") {
      console.log("Using development build");
    }
    // tslint:disable: no-console
    Config = {
      // No leading / !
      backendAPIURL: "https://ws-talk-stg.yacast.fr",
      CMUrl: "https://catalog.yacast.fr",
      UsersUrl: "https://users.yacast.fr",
      backendRetries: -1,
      backendRetriesCapping: 1000,
      backendRetriesStart: 1000,
      environment: Environment.STAGING,
      logLevel: "debug",
      version: `${version} (staging)`,
    };
    break;
  case Environment.DEV:
  default:
    // tslint:disable: no-console
    if ("console" in window && typeof console.log === "function") {
      console.log("Using development build");
    }
    // tslint:disable: no-console
    Config = {
      // No leading / !
      backendAPIURL: "https://ws-talk.yacast.fr",
      CMUrl: "https://catalog.yacast.fr",
      UsersUrl: "https://users.yacast.fr",
      backendRetries: -1,
      backendRetriesCapping: 1000,
      backendRetriesStart: 1000,
      environment: Environment.DEV,
      logLevel: "debug",
      version: `${version} (dev)`,
    };
}
